import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BloxButton } from 'styled_components/Common/BloxButton';
import TextInput from 'sub_components/Common/BloxTextInput';
import WhiteListContainer from 'sub_components/Storage/WhiteListContainer';
import * as StorageUtils from 'utils/StorageUtils';
import { SuccessMessage, ErrorMessage } from 'utils/CommonConstants';
import { StorageApi } from 'services/storage';
import { bool } from 'prop-types';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const deleteVipDefault = `${CDN_URL}storage/delete-vip-default-lg.svg`;
const deleteVipSelected = `${CDN_URL}storage/delete-vip-select-lg.svg`;
const deleteVipHover = `${CDN_URL}storage/delete-vip-hover-lg.svg`;

const addVipDefault = `${CDN_URL}storage/add-vip-default-lg.svg`;
const addVipSelected = `${CDN_URL}storage/add-vip-select-lg.svg`;
const addVipHover = `${CDN_URL}storage/add-vip-hover-lg.svg`;
const ipLabelEmerald = `${CDN_URL}storage/ip-whitelist-entry-label.svg`;
const ipLabel = `${CDN_URL}storage/ip-whitelist-form-label.svg`;

class WhiteList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: {},
			selected: null,
			share: null,
			showText: false,
			showWhiteListModal: false,
			displayInput: false,
			comment: null,
			clicked: false,
			ticketID: null,
		};
	}

	onMouseEnter = (id, type) => {
		const icon = document.getElementById(id);
		const { clicked } = this.state;
		const defaultImageDelete = clicked ? deleteVipSelected : deleteVipHover;
		const defaultImageAdd = clicked ? addVipSelected : addVipHover;
		if (type === 'Delete') {
			icon.src = defaultImageDelete;
		} else {
			icon.src = defaultImageAdd;
		}
	};
	onMouseLeave = (id, type) => {
		const icon = document.getElementById(id);
		const { clicked } = this.state;
		const defaultImageDelete = clicked ? deleteVipSelected : deleteVipDefault;
		const defaultImageAdd = clicked ? addVipSelected : addVipDefault;
		if (type === 'Delete') {
			icon.src = defaultImageDelete;
		} else {
			icon.src = defaultImageAdd;
		}
	};

	formatUpdateWhitelistParams = (requestType, newWhitelist) => {
		const {
			currentWhitelist,
			share,
			auth_status: {
				user: { id },
			},
			vip,
		} = this.props;
		const { comment } = this.state;
		const addWhitelist = [];
		const removeWhitelist = [];

		if (requestType === 'Delete') {
			removeWhitelist.push(currentWhitelist);
		} else {
			addWhitelist.push({
				id: share?.storage_id,
				storageId: share?.storage_id,
				whitelist_ip_address: newWhitelist?.[0],
				vip_address: vip?.vip_address,
				state: '',
				subnet_mask: '',
				comment,
			});
		}

		return {
			addWhitelist,
			removeWhitelist,
			userId: id,
		};
	};

	updateWhitelist = (requestType, newWhiteList) => {
		const { clicked } = this.state;
		const {
			share,
			company_info: {
				customer: { id },
			},
		} = this.props;
		if (!clicked) {
			this.setState({ clicked: true });
			const { setModalContent, refreshShare } = this.props;
			const params = this.formatUpdateWhitelistParams(requestType, newWhiteList);

			setModalContent('CLOSE');
			const button = (
				<BloxButton
					className='buttons41'
					id='okay'
					text='OKAY'
					module='storage'
					enabled={true}
					onClick={() => {}}
					cypressId='okay'
				/>
			);
			StorageApi.updateWhitelists(params, id, share?.storage_id)
				.then(response => {
					if (response.status === 200 && !response.data.error) {
						setModalContent('TIMEOUT_CLOSE', SuccessMessage, button);
						refreshShare();
						this.setState({
							comment: '',
							data: { ips: [], dirty: [] },
							clicked: false,
						});
					} else {
						setModalContent('TIMEOUT_CLOSE', ErrorMessage, button);
					}
				})
				.catch(() => {
					setModalContent('TIMEOUT_CLOSE', ErrorMessage, button);
				});
		}
	};

	addWhiteList = () => {
		this.setState({ displayInput: true });
	};

	onChange = event => {
		this.setState({ comment: event.target.value });
	};

	attachSubnetToIps = ips => {
		return ips && ips.length
			? ips.map(ip => {
					return /\/$/.test(ip.ip) ? `${ip.ip}32` : ip.ip;
			  })
			: { ips: [] };
	};
	onSelect = params => {
		this.setState({ data: params.data });
	};

	allIpsValid = ips => {
		return ips.every(ip => StorageUtils.validateIpAddress(ip.ip));
	};
	getSharesWithSameVip = (shares, vip) => {
		const selectedVIP = vip;
		const shareWithSameVip = [];
		shares.filter(share => {
			const locations = share?.locations;
			if (locations && locations.length !== 0) {
				locations.forEach(location => {
					const vips = location?.vips;
					if (vips && vips.length !== 0) {
						vips.forEach(vip => {
							if (vip?.ipAddress === selectedVIP?.ipAddress) {
								shareWithSameVip.push(share?.common_name);
							}
						});
					}
				});
			}
		});
		return shareWithSameVip;
	};

	showInfoModal = (type, newWhiteList) => {
		const { setModalContent, shares, vip } = this.props;
		const vips = this.getSharesWithSameVip(shares, vip);
		const button = (
			<BloxButton
				className='buttons41'
				id='confirm-whitelist'
				text='CONTINUE'
				module='storage'
				enabled={true}
				onClick={() => {
					this.updateWhitelist(type, newWhiteList);
				}}
				cypressId='continue'
			/>
		);
		const message = `Changing whitelist affects all containers associated to this VIP : ${vips}`;

		setModalContent('OPEN', message, button);
	};
	onCancel = () => {
		const { setModalContent } = this.props;
		setModalContent('CLOSE');
	};

	render() {
		const { displayInput, data: { ips, dirty } = {}, comment, clicked } = this.state;
		const { currentWhitelist, index, type, editWhitelist } = this.props;
		const formattedWhitelist = this.attachSubnetToIps(ips);
		const defaultImageDelete = clicked ? deleteVipSelected : deleteVipDefault;
		const defaultImageAdd = clicked ? addVipSelected : addVipDefault;
		const valid =
			ips && ips.length > 0 && this.allIpsValid(ips) && comment !== '' && comment !== null;

		return (
			<>
				{type === 'Delete' && (
					<div className='whitelist-wrapper'>
						<div className='ip-label'>
							<img src={ipLabel} />
						</div>
						<div className='ip body10'>{currentWhitelist?.whitelist_ip_address}</div>
						<div className='comment'>
							<div className='text body10'>{currentWhitelist?.comment}</div>
						</div>
						<div className='whitelist-button-wrapper'>
							{editWhitelist && (
								<img
									src={defaultImageDelete}
									id={`whitelist-${index}${type}`}
									className='vip-button'
									data-cy={`whitelist-${index}-${type}`}
									onMouseEnter={() => this.onMouseEnter(`whitelist-${index}${type}`, type)}
									onMouseLeave={() => this.onMouseLeave(`whitelist-${index}${type}`, type)}
									onClick={() => this.showInfoModal(type)}
								/>
							)}
						</div>
					</div>
				)}
				{type === 'Add' && editWhitelist && (
					<div className={displayInput ? 'add-whitelist active' : 'add-whitelist'}>
						<div className='ip-label'>
							<img src={displayInput ? ipLabelEmerald : ipLabel} />
						</div>
						{!displayInput && (
							<div
								className='add-text heading60'
								onClick={this.addWhiteList}
								data-cy='add-to-whitelist'
							>
								ADD TO WHITELIST
							</div>
						)}
						{displayInput && (
							<div className='input-section-wrapper'>
								<div className='input-fields-wrapper'>
									<div className='ip-address'>
										{/* <div className='label body10'>IP Address</div> */}
										<WhiteListContainer
											ips={formattedWhitelist}
											dirty={dirty}
											onSelect={this.onSelect}
											update={this.update}
											useButton={false}
											single={true}
										/>
									</div>
									<div className='comment'>
										<div className='label body10'>Comments</div>
										<div className='comment-input'>
											<TextInput
												placeholder='Add a comment'
												label=''
												name='whitelist-comment'
												value={comment}
												onChange={this.onChange}
												active={true}
												cypressId='whitelist-comment'
											/>
										</div>
									</div>
								</div>
								<div className='whitelist-button-wrapper'>
									{editWhitelist && (
										<img
											src={defaultImageAdd}
											id={`whitelist-${index}${type}`}
											data-cy={`whitelist-${index}-${type}`}
											className={valid ? 'whitelist-add-button' : 'whitelist-add-button disabled'}
											onMouseEnter={() => this.onMouseEnter(`whitelist-${index}${type}`, type)}
											onMouseLeave={() => this.onMouseLeave(`whitelist-${index}${type}`, type)}
											onClick={
												valid ? () => this.showInfoModal(type, formattedWhitelist) : () => {}
											}
										/>
									)}
								</div>
							</div>
						)}
					</div>
				)}
			</>
		);
	}
}
WhiteList.propTypes = {
	editWhitelist: bool,
};

WhiteList.defaultProps = {
	editWhitelist: true,
};

function mapStateToProps(state) {
	return {
		site: state.site_tracking,
		auth_status: state.auth_status,
		company_info: state.company_info,
	};
}

export default connect(mapStateToProps, null)(WhiteList);
